import request from '@/utils/request'

let BASEROOT          = '/visitor/v2'

//商脉圈列表(展商)
export function getCommercialDistrictList(query) {
  return request({
    url: BASEROOT + '/commercialDistrict/commercialDistrictList',
    method: 'post',
    data: query
  })
}

//商脉圈列表(客商 带置顶数据)
export function getCommercialDistrictTopList(query) {
  return request({
    url: BASEROOT + '/commercialDistrict/commercialDistrictTopList',
    method: 'post',
    data: query
  })
}


// 我的商脉圈列表
export function getMyCommercialDistrictList(query) {
  return request({
    url: BASEROOT + '/commercialDistrict/getMyCommercialDistrictList',
    method: 'post',
    data: query
  })
}

// 删除商脉圈
export function deleteCommercialDistrict(query) {
  return request({
    url: BASEROOT + '/commercialDistrict/deleteCommercialDistrict',
    method: 'post',
    data: query
  })
}

//评论
export function addCommercialDistrictComment(query) {
  return request({
    url: BASEROOT + '/commercialDistrictComment/addCommercialDistrictComment',
    method: 'post',
    data: query
  })
}

//点赞
export function addCommercialDistrictLike(query) {
  return request({
    url: BASEROOT + '/commercialDistrictLike/addCommercialDistrictLike',
    method: 'post',
    data: query
  })
}

//获取接受对象
export function questionSite(query) {
  return request({
    url: BASEROOT + '/customQuestions/questionSite',
    method: 'post',
    data: query
  })
}

//发布商脉圈
export function saveCommercialDistrict(query) {
  return request({
    url: BASEROOT + '/commercialDistrict/saveCommercialDistrict',
    method: 'post',
    data: query
  })
}
// 是否可以发布商脉圈
export function isSendCommercialDistrict(query) {
  return request({
    url: BASEROOT + '/commercialDistrict/judgeSend',
    method: 'post',
    data: query
  })
}